export default __webpack_public_path__ + "static/media/MoGoLogo.5b9d32fb.png";